module.exports = __webpack_public_path__ + "img/ElectricWarning.04667a38.svg";